// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-p {
  font-size: 18px;
}
.template-span {
  font-size: 16px;
}
.template-input_wrapper {
  max-width: 160px;
}

.template-input {
  background: white !important;
  border-radius: 3px;
  margin-right: 8px;
  width: 250px;
  min-width: 250px;
  border: 2px solid #b7d423;
  padding: 10px;
}

.template-input-date {
  border: 2px solid #ffce1b;

  padding: 6px 12px;
  border-radius: 3px;
}

.template-input::placeholder {
  color: #b7d423;
}

.html-object-embed::before {
  display: none;
}
.html-object-embed {
  outline: 0 !important;
  padding: 0 !important;
}
.template-hrline {
  background-color: black;
  width: 100%;
  height: 2px;
}
.template-border {
  width: auto;
  display: block;
  border: 2px solid black;
}
.green-circle {
  background-color: #b7d423;
  color: black;

  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ck-widget.html-object-embed {
  background: transparent !important;
  height: auto;
  min-width: 14px !important;
}
.html-object-embed__content {
  min-width: min-content !important;
}

.template-dropdown {
  padding: 10px 20px;

  border: 2px solid #b7d423;
  color: #b7d423;
  background-color: transparent;
}

.template-checkbox {
  width: 100% !important;
}

.template-ui_select {
  padding: 0.8rem 1rem;
  border: 2px solid #b7d423;
  color: #b7d423;
  outline: 0;
  background: transparent;
  border-radius: 8px;
}
.template-ui_select option {
  color: red;
}
.template-esign {
  color: #b4a7d6 !important;
  width: 160px;
  min-width: 160px;
  min-height: 55px;
  margin: 15px 30px;
  border: 1px solid #b4a7d6;
}
.template-esign::placeholder {
  color: #b4a7d6 !important;
}

.template-input-color {
  border: 1px solid #ea9999;
  color: #ea9999 !important;
}
.template-input-color::placeholder {
  color: #ea9999 !important;
}
.template-dropdown-color {
  border: 1px solid #ffe599;
  color: #ffe599 !important;
}
.template-dropdown-color::placeholder {
  color: #ffe599 !important;
}
.template-recipient-input-color {
  border: 1px solid #a4c2f4;
  color: #a4c2f4 !important;
}

.template-recipient {
  margin-top: 20px;
}

.template-recipient-input-color::placeholder {
  color: #a4c2f4 !important;
}
.preview-esign {
  border-color: #b4a7d6 !important;
  color: #b4a7d6 !important;
}
.input-esign {
  min-width: 60px;
}
.no-border {
  border: 0px solid transparent;

  font-size: 14px;
  position: relative;
  bottom: 2px;
  font-family: 'Gilroy-medium', sans-serif;
}
.table-input {
  width: auto !important;
}

.ck.ck-editor__editable_inline > :last-child {
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/template.styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;;EAEzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAWA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,YAAY;;EAEZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;;EAElB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;;EAE7B,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".template-p {\n  font-size: 18px;\n}\n.template-span {\n  font-size: 16px;\n}\n.template-input_wrapper {\n  max-width: 160px;\n}\n\n.template-input {\n  background: white !important;\n  border-radius: 3px;\n  margin-right: 8px;\n  width: 250px;\n  min-width: 250px;\n  border: 2px solid #b7d423;\n  padding: 10px;\n}\n\n.template-input-date {\n  border: 2px solid #ffce1b;\n\n  padding: 6px 12px;\n  border-radius: 3px;\n}\n\n.template-input::-webkit-input-placeholder {\n  color: #b7d423;\n  text-align: center;\n}\n\n.template-input:-ms-input-placeholder {\n  color: #b7d423;\n}\n\n.template-input::placeholder {\n  color: #b7d423;\n}\n\n.html-object-embed::before {\n  display: none;\n}\n.html-object-embed {\n  outline: 0 !important;\n  padding: 0 !important;\n}\n.template-hrline {\n  background-color: black;\n  width: 100%;\n  height: 2px;\n}\n.template-border {\n  width: auto;\n  display: block;\n  border: 2px solid black;\n}\n.green-circle {\n  background-color: #b7d423;\n  color: black;\n\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ck-widget.html-object-embed {\n  background: transparent !important;\n  height: auto;\n  min-width: 14px !important;\n}\n.html-object-embed__content {\n  min-width: min-content !important;\n}\n\n.template-dropdown {\n  padding: 10px 20px;\n\n  border: 2px solid #b7d423;\n  color: #b7d423;\n  background-color: transparent;\n}\n\n.template-checkbox {\n  width: 100% !important;\n}\n\n.template-ui_select {\n  padding: 0.8rem 1rem;\n  border: 2px solid #b7d423;\n  color: #b7d423;\n  outline: 0;\n  background: transparent;\n  border-radius: 8px;\n}\n.template-ui_select option {\n  color: red;\n}\n.template-esign {\n  color: #b4a7d6 !important;\n  width: 160px;\n  min-width: 160px;\n  min-height: 55px;\n  margin: 15px 30px;\n  border: 1px solid #b4a7d6;\n}\n.template-esign::placeholder {\n  color: #b4a7d6 !important;\n}\n\n.template-input-color {\n  border: 1px solid #ea9999;\n  color: #ea9999 !important;\n}\n.template-input-color::placeholder {\n  color: #ea9999 !important;\n}\n.template-dropdown-color {\n  border: 1px solid #ffe599;\n  color: #ffe599 !important;\n}\n.template-dropdown-color::placeholder {\n  color: #ffe599 !important;\n}\n.template-recipient-input-color {\n  border: 1px solid #a4c2f4;\n  color: #a4c2f4 !important;\n}\n\n.template-recipient {\n  margin-top: 20px;\n}\n\n.template-recipient-input-color::placeholder {\n  color: #a4c2f4 !important;\n}\n.preview-esign {\n  border-color: #b4a7d6 !important;\n  color: #b4a7d6 !important;\n}\n.input-esign {\n  min-width: 60px;\n}\n.no-border {\n  border: 0px solid transparent;\n\n  font-size: 14px;\n  position: relative;\n  bottom: 2px;\n  font-family: 'Gilroy-medium', sans-serif;\n}\n.table-input {\n  width: auto !important;\n}\n\n.ck.ck-editor__editable_inline > :last-child {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
